export const getEmoji = (text) => {
  const emojiRegex = /\p{Extended_Pictographic}/u
  const textRegex = /(https?:\/\/|www\.)?[^\s\p{Extended_Pictographic}]+|#\w+|(\p{Extended_Pictographic}+|[^\w\s]+|[\p{L}\p{N}'_+]+[.,!?]*|\s+|\n+)/gu

  return [ ...text.matchAll(textRegex) ].map(match => {
    const part = match[0]

    return {
      text: part,
      isEmoji: emojiRegex.test(part),
    }
  })
}
